import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getUser } from '../../selectors/analytics';
import { IBrokerAnalyticsUser } from '../../types/broker';

export const useBrokerAnalyticsUser = (isAccountLegalTypeIndividual?: boolean) => {
  const user = useSelector(getUser);
  const extra = isAccountLegalTypeIndividual ? { is_individual: isAccountLegalTypeIndividual } : undefined;

  return useMemo<IBrokerAnalyticsUser>(
    () => ({
      ...user,
      extra,
    }),
    [user, isAccountLegalTypeIndividual, extra],
  );
};
